var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9816 17H22.0184C21.5576 17 21.1889 16.6221 21.1889 16.1705V13.8111H18.8295C18.3687 13.8111 18 13.4332 18 12.9816V9.01843C18 8.5576 18.3687 8.18894 18.8295 8.18894H21.1889V5.82949C21.1889 5.36866 21.5576 5 22.0184 5H25.9816C26.4424 5 26.8111 5.37788 26.8111 5.82949V8.18894H29.1705C29.6313 8.18894 30 8.56682 30 9.01843V12.9816C30 13.4424 29.6313 13.8111 29.1705 13.8111H26.8111V16.1705C26.8111 16.6221 26.4424 17 25.9816 17ZM22.8571 15.3318H25.1521V12.9724C25.1521 12.5115 25.5207 12.1429 25.9816 12.1429H28.341V9.84793H25.9816C25.5207 9.84793 25.1521 9.47005 25.1521 9.01843V6.65899H22.8571V9.01843C22.8571 9.47926 22.4885 9.84793 22.0276 9.84793H19.6682V12.1429H22.0276C22.4885 12.1429 22.8571 12.5207 22.8571 12.9724V15.3318V15.3318Z",
    fill: "#F9D336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22C17.9314 22 13 17.0686 13 11C13 4.93138 17.9314 0 24 0C30.0686 0 35 4.93138 35 11C35 17.0686 30.0686 22 24 22ZM24 1.82159C18.9378 1.82159 14.8216 5.93779 14.8216 11C14.8216 16.0622 18.9378 20.1784 24 20.1784C29.0622 20.1784 33.1784 16.0622 33.1784 11C33.1784 5.93779 29.0622 1.82159 24 1.82159Z",
    fill: "#AEB5BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0005 39C27.3142 39 30.0005 36.0899 30.0005 32.5C30.0005 28.9101 27.3142 26 24.0005 26C20.6868 26 18.0005 28.9101 18.0005 32.5C18.0005 36.0899 20.6868 39 24.0005 39Z",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00049 40C11.7619 40 14.0005 37.5376 14.0005 34.5C14.0005 31.4624 11.7619 29 9.00049 29C6.23906 29 4.00049 31.4624 4.00049 34.5C4.00049 37.5376 6.23906 40 9.00049 40Z",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0005 38V41C28.3705 41.44 31.9405 43.14 33.3805 43.74C33.5647 43.8157 33.7221 43.9446 33.8326 44.1103C33.943 44.276 34.0015 44.4709 34.0005 44.67V47H14.0005V44.66C14.0006 44.4637 14.0586 44.2718 14.167 44.1082C14.2755 43.9446 14.4297 43.8166 14.6105 43.74L21.0005 41V38",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00049 39V42L1.68049 43.77C1.48187 43.8371 1.30936 43.9649 1.18733 44.1354C1.06531 44.3058 0.99995 44.5104 1.00049 44.72V47H11.0005",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0005 40C41.7619 40 44.0005 37.5376 44.0005 34.5C44.0005 31.4624 41.7619 29 39.0005 29C36.2391 29 34.0005 31.4624 34.0005 34.5C34.0005 37.5376 36.2391 40 39.0005 40Z",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0005 39V42L46.3205 43.77C46.5191 43.8371 46.6916 43.9649 46.8136 44.1354C46.9357 44.3058 47.001 44.5104 47.0005 44.72V47H37.0005",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 40V42L13.0005 43",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupHelp);
export default __webpack_public_path__ + "static/media/group-help.47adaa50efd69388bca337eb1fa75ac6.svg";
export { ForwardRef as ReactComponent };